import { useId, useState } from "react";

export const BeforeAfterSlider = ({ afterImage, beforeImage, title }) => {
  const [position, setPosition] = useState(50);
  const sliderId = useId();

  if (!beforeImage || !afterImage) {
    return (
      <div className="luxury-panel p-6 text-sm text-slate-300" data-testid="before-after-fallback-panel">
        Virtual staging images will appear here once the media pair is assigned.
      </div>
    );
  }

  return (
    <div className="space-y-4 rounded-[28px] border border-[#001935]/10 bg-white/80 p-6 shadow-[0_18px_60px_rgba(0,25,53,0.06)]" data-testid="before-after-slider-section">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#051a35]">Virtual Staging</p>
          <h3 className="mt-2 text-3xl font-semibold text-[#001935]">{title}</h3>
          <p className="mt-3 text-sm leading-7 text-[#6b6252]" data-testid="before-after-slider-instruction">
            Drag the gold divider to compare the original view with the staged version.
          </p>
        </div>
        <div className="flex gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">
          <span>Before</span>
          <span>/</span>
          <span>After</span>
        </div>
      </div>

      <div className="overflow-hidden rounded-[28px] border border-[#001935]/10 bg-[#eef2f6]">
        <div className="relative aspect-[1.35/1] w-full overflow-hidden" data-testid="before-after-slider-stage">
          <img alt="Before staging" className="absolute inset-0 h-full w-full object-cover" decoding="async" loading="lazy" src={beforeImage} />
          <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}>
            <img alt="After staging" className="h-full w-full object-cover" decoding="async" loading="lazy" src={afterImage} />
          </div>
          <div className="absolute inset-y-0 z-10 flex -translate-x-1/2 flex-col items-center" data-testid="before-after-slider-divider" style={{ left: `${position}%` }}>
            <div className="h-full w-[2px] bg-white/80 shadow-[0_0_0_1px_rgba(0,25,53,0.18)]" />
            <div className="absolute top-1/2 flex h-14 w-14 -translate-y-1/2 items-center justify-center rounded-full border-2 border-[#001935] bg-[#D4AF37] text-lg font-bold text-[#001935] shadow-[0_10px_30px_rgba(0,25,53,0.18)]" data-testid="before-after-slider-handle">
              ⇆
            </div>
          </div>
        </div>

        <div className="border-t border-[#001935]/10 bg-white px-5 py-4">
          <div className="flex items-center justify-between gap-3 text-xs font-bold uppercase tracking-[0.2em] text-[#8b6d16]">
            <span>Before</span>
            <label className="sr-only" htmlFor={sliderId}>Adjust before and after comparison</label>
            <span>After</span>
          </div>
          <input
            className="mt-3 h-2 w-full cursor-ew-resize accent-[#D4AF37]"
            data-testid="before-after-slider-range"
            id={sliderId}
            max="100"
            min="0"
            onChange={(event) => setPosition(Number(event.target.value))}
            type="range"
            value={position}
          />
        </div>
      </div>
    </div>
  );
};